import { render, staticRenderFns } from "./autocomplete-suggestions.vue?vue&type=template&id=00d281ac&scoped=true&"
import script from "./autocomplete-suggestions.vue?vue&type=script&lang=js&"
export * from "./autocomplete-suggestions.vue?vue&type=script&lang=js&"
import style0 from "./autocomplete-suggestions.vue?vue&type=style&index=0&id=00d281ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d281ac",
  null
  
)

export default component.exports